export default __webpack_public_path__ + "static/media/spa-icon.4461a93a.svg";